import { render } from "./SidePanelAdmin.vue?vue&type=template&id=fe046870&scoped=true"
import script from "./SidePanelAdmin.vue?vue&type=script&lang=js"
export * from "./SidePanelAdmin.vue?vue&type=script&lang=js"

import "./SidePanelAdmin.vue?vue&type=style&index=0&id=fe046870&scoped=true&lang=css"
import "../assets/bootstrap.min.css?vue&type=style&index=1&id=fe046870&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe046870"]])

export default __exports__